import { render, staticRenderFns } from "./IconPen02.vue?vue&type=template&id=7a8fe753"
import script from "./IconPen02.vue?vue&type=script&lang=ts"
export * from "./IconPen02.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports